import { memo } from 'react';

import type { FC, SVGAttributes } from 'react';

export interface InfoBlockIconProps extends SVGAttributes<SVGSVGElement> {
  className?: string;
}

const InfoBlockIcon: FC<InfoBlockIconProps> = (props) => {
  return (
    <svg
      {...props}
      width='108'
      height='77'
      viewBox='0 0 108 77'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect x='22.4004' y='18.1963' width='79.6' height='53.6' fill='#BEEBFF' stroke='#404040' />
      <rect x='18.5' y='71.4961' width='87.4' height='4.2' fill='#BEEBFF' stroke='#404040' />
      <path
        d='M80.9457 45.0922V41.4868C80.9457 40.2297 79.9942 39.2683 78.7499 39.2683H64.9165C63.6722 39.2683 62.7207 40.2297 62.7207 41.4868M62.7207 41.4868C62.7207 40.2297 61.7692 39.2683 60.5249 39.2683H46.6916C45.4473 39.2683 44.4957 40.2297 44.4957 41.4868V45.1128M62.7207 41.4868V45.0922M85.7764 47.4024C85.7764 46.1453 84.8249 45.184 83.5806 45.184H41.8608C40.6165 45.184 39.665 46.1453 39.665 47.4024V49.6208M79.7485 49.6947H39.665V56.3499C39.665 57.607 40.6165 58.5682 41.8608 58.5682H76.6435M84.1662 45.184V34.0182C84.1662 32.7611 83.2146 31.7998 81.9704 31.7998H43.4711C42.2268 31.7998 41.2753 32.7611 41.2753 34.0182V45.184H84.1662ZM43.6906 58.5682V62.8571H45.2277L46.106 59.7514V58.5682H43.6906Z'
        stroke='#404040'
        strokeMiterlimit='10'
      />
      <circle cx='85.5996' cy='56.6963' r='9.05859' stroke='#404040' />
      <path d='M85.5283 50.7876V62.7097' stroke='#404040' />
      <path d='M91.4883 56.749L79.5662 56.749' stroke='#404040' />
      <circle cx='18' cy='17.6963' r='16.8613' fill='white' stroke='#404040' />
      <path
        d='M19.0472 11.3163H19.7132V23.1963H17.8052V13.5663L15.3932 14.3403L14.9252 12.6663L19.0472 11.3163Z'
        fill='#404040'
      />
    </svg>
  );
};

export default memo(InfoBlockIcon);
